import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import {getLocalTime} from "shared/Utils/DateUtils";
import s from "./MessageCreated.pcss";

export default function MessageCreated(props) {
    const {timestamp, dateVisible, isAlt} = props;

    return (
        <div
            className={classNames(s.created, props.className, {
                [s.alt]: isAlt,
                [s.visible]: dateVisible,
            })}
        >
            {timestamp ? (
                <time dateTime={timestamp}>{getLocalTime(timestamp).format("LT")}</time>
            ) : (
                ""
            )}
        </div>
    );
}

MessageCreated.propTypes = {
    timestamp: PropTypes.string.isRequired,
};
